/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/react-sortable-hoc/~/lodash/_freeGlobal.js
// module id = 1370
// module chunks = 4